import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { driver } from "driver.js";

@Component({
  selector: 'vex-leave-workout-popup',
  templateUrl: './leave-workout-popup.component.html',
  styleUrls: ['./leave-workout-popup.component.scss']
})
export class LeaveWorkoutPopupComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService) { }

  ngOnInit() {
    setTimeout(() => {
      localStorage.getItem('tourWorkoutExecutionPauseShowed') ? null : this.startTour();
    }, 800);
  }

  leave(){
    this.dialogRef.close('stop');
  }

  resume(){
    this.dialogRef.close();
  }

  startTour(): void {
    localStorage.setItem('tourWorkoutExecutionPauseShowed', 'true')

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.pause-container', popover: { title: this.translate.instant('TUTORIALS.workout-execution.resumeOrQuitTitle'), description: this.translate.instant('TUTORIALS.workout-execution.resumeOrQuitDescription') } }
      ]
    });

    driverObj.drive();
  }

}
